import { cookie } from '@pdrj/pmi-iqos-shared-react'

export default class IqosphereQuiz {
  constructor(api) {
    this.api = api
  }

  getQuiz = async (campaignName, versionName, includeResult = false) => {
    const res = await this.api.get(
      '/iqosphere/quiz/status' +
        '?campaignName=' +
        campaignName +
        '&versionName=' +
        versionName +
        (includeResult ? '&includeResult=true' : ''),
      {
        headers: {
          ...cookie.authorizationTokenHeader()
        },
        mock: this.api.getMock('getQuizStatus'),
        data: { campaignName, versionName, includeResult }
      }
    )
    return res
  }

  submitQuizAnswer = async (
    campaignName,
    versionName,
    questionIdx,
    answerIdx
  ) => {
    const res = await this.api.post('/iqosphere/quiz/submit?rpc=true', {
      headers: {
        ...cookie.authorizationTokenHeader()
      },
      useProxy: true,
      withCredentials: true,
      mock: this.api.getMock('quizAnswer'),
      data: { campaignName, versionName, questionIdx, answerIdx }
    })
    return res
  }

  submitActivityQuizAnswer = async (action, mission, answer) => {
    const res = await this.api.post('/iqosphere/activity/quiz/submit', {
      headers: {
        ...cookie.authorizationTokenHeader()
      },
      useProxy: true,
      withCredentials: true,
      mock: this.api.getMock('quizMissionAnswer'),
      data: { action, mission, answer }
    })
    return res
  }

  submitPollAnswer = async ({ action, answer, mission }) => {
    console.log({ action, answer, mission })
    const res = await this.api.post('/iqosphere/activity/poll/submit', {
      headers: {
        ...cookie.authorizationTokenHeader()
      },
      useProxy: true,
      withCredentials: true,
      mock: this.api.getMock('opinionPollResult'),
      data: { action, mission, answer }
    })
    return res
  }
}
